export function getPurchaseSizeFromPartySize(
  partySize: number,
  singleUnitQuantity = 1,
  isPartySizeLess = false
): number {
  if (isPartySizeLess) {
    return 1;
  }
  return Math.ceil(partySize / singleUnitQuantity);
}

export function getMaxPartySizeFromPurchaseSize(purchaseSize: number, singleUnitQuantity = 1) {
  return purchaseSize * singleUnitQuantity;
}

export function getMinPartySizeFromPurchaseSize(purchaseSize: number, singleUnitQuantity = 1) {
  return purchaseSize * singleUnitQuantity - (singleUnitQuantity - 1);
}
